<template>
  <el-form-item prop="settype" class="settype">
    <el-radio-group v-model="setType" @change="handleChange">
      <el-radio v-for="item in options" :key="item.id" class="approval-type" :label="item.type">
        {{ item.label }}
      </el-radio>
    </el-radio-group>
  </el-form-item>
</template>

<script>
export default {
  props: {
    // 选项
    options: {
      default: () => [],
      type: Array
    },
    // 初始化值
    value: {
      default: ''
    }
  },
  data() {
    return {
      setType: this.value
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style></style>
